module.exports = __webpack_public_path__ + "img/grinning_face_with_smiling_eyes.2001e416.gif";